var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCountryParam } from "@/hooks/useCountryParam";
import { ButtonGroup, Center, useRecipe } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { getPageParams } from "@/components/Pagination/PageButtonHelper";
import { NextPageButton } from "./NextPageButton";
import { PageNumberButtons } from "./PageNumberButtons";
import { PrevPageButton } from "./PrevPageButton";
export var PaginationSerp = function (_a) {
    var pageCursors = _a.pageCursors;
    var recipe = useRecipe({ key: "PaginationSerp" });
    var styles = recipe({});
    var _b = useSearchParams(), searchParams = _b[0], setSearchParams = _b[1];
    var countryParam = useCountryParam();
    if (pageCursors.size === 0) {
        return _jsx(_Fragment, {});
    }
    var handleClick = function (e, cursor) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        e.nativeEvent.preventDefault();
        setSearchParams(getPageParams(searchParams, cursor, countryParam));
        // The timeout is required as we need to wait for the rendered results to update
        setTimeout(function () {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    };
    var props = {
        pageCursors: pageCursors,
        searchParams: searchParams,
        pageClickHandler: handleClick,
        countryParam: countryParam,
    };
    return (_jsx(Center, __assign({ as: "nav", role: "navigation", "aria-label": "Pagination", css: styles }, { children: _jsxs(ButtonGroup, __assign({ size: "sm", attached: true, variant: "outline" }, { children: [_jsx(PrevPageButton, __assign({}, props)), _jsx(PageNumberButtons, __assign({}, props)), _jsx(NextPageButton, __assign({}, props))] })) })));
};
